import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { getOrderByIdUseCase } from '../../application/use-cases/get-order-by-id/get-order-by-id.use-case';
import { ORDER_REPOSITORY } from '../tokens/update-order-shipping.tokens';

export const orderResolver: ResolveFn<any> = (route, _state) => {
    const store = inject(Store);

    const orderRepository = inject(ORDER_REPOSITORY);

    const orderId: string = route.paramMap.get('id');

    return getOrderByIdUseCase(store, orderRepository, +orderId).pipe(
        map(({ value }) => value),
    );
};
